import * as React from 'react';
import { idMatchesActiveItemId } from '../../Header,helpers';
import { NavigationItemModel } from '../../Header.types';
import DesktopNavigationDropdownLink from '../DesktopNavigationDropdownLink/DesktopNavigationDropdownLink';
import S from './ProductDropdown.styles';
import VariantA from './Variants/VariantA';
import VariantB from './Variants/VariantB';

export type ProductDropdownProps = {
  items: NavigationItemModel[];
  visible: boolean;
  productsVariant?: 'A' | 'B';
  translations: Record<string, string>;
};

const ProductDropdown: React.FC<ProductDropdownProps> = ({ items, visible, productsVariant, translations }) => {
  const [activeItemId, setActiveItemId] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (visible) {
      return;
    }

    setActiveItemId(null);
  }, [visible]);

  return (
    <S.Container aria-current={visible}>
      <S.Column>
        {items &&
          items.map((item) => (
            <DesktopNavigationDropdownLink
              key={item.id}
              item={item}
              dropdownLevel="1"
              active={idMatchesActiveItemId(item.id, activeItemId)}
              onHover={(itemId) => setActiveItemId(itemId)}
              translations={translations}
            />
          ))}
      </S.Column>
      {renderColumnsByVariant()}
    </S.Container>
  );

  function renderColumnsByVariant(): React.ReactNode {
    const dropdownLevelTwo = items.map((item) => item.children);
    const dropdownLevelThree = dropdownLevelTwo.flatMap((item) => item && item.map((item) => item.children));

    const levels = [dropdownLevelTwo, dropdownLevelThree];

    switch (productsVariant) {
      case 'A':
        return (
          <VariantA
            levels={levels}
            activeItemId={activeItemId}
            onHover={(itemId) => setActiveItemId(itemId)}
            translations={translations}
          />
        );
      case 'B':
        return <VariantB levels={levels.slice(0, 1)} activeItemId={activeItemId} translations={translations} />;
      default:
        return null;
    }
  }
};

export default ProductDropdown;
